// @ts-check
import { useQuery } from '@tanstack/react-query';
import api from 'modules/queries/api';

/**
 * @param {import('club-sauce/public/project/index.raw').LWApiPublicProjectAvailableAssetsParamsRawI} params
 * @param {import('@tanstack/react-query').UseQueryOptions<import('club-sauce/public/project/index.raw').LWApiPublicProjectAvailableAssetsResultRawI>} [options]
 */
const useProjectAvailableAssets = (params, options) =>
	useQuery({
		queryKey: ['/project/availableAssets', params],
		queryFn: () => api.project.apiRaw.availableAssets(params),
		...options,
	});

export default useProjectAvailableAssets;
